import * as React from 'react';
import classNames from 'classnames';
import { CnTabContext } from './context';
import { useGuid } from '@/utils/use-guid';
import isString from 'lodash/isString';
import './item.scss';
export const CnTabItem = React.forwardRef((props, ref) => {
    const { type, className, itemKey, title = '', children, onClick = () => { }, renderContent = null, ...others } = props;
    const { activeKey, change } = React.useContext(CnTabContext);
    const active = `${activeKey}` === `${itemKey}`;
    const clsPrefix = 'cn-ui-m-tab-item';
    const curItemId = useGuid('tab-item-');
    const classes = {
        tab: classNames(clsPrefix, {
            [`${clsPrefix}--active`]: active,
        }, `${clsPrefix}-type-${type}`, className),
        activeLine: `${clsPrefix}-active-line`,
        tabText: classNames(`${clsPrefix}-text`, {
            [`${clsPrefix}-text--active`]: active,
        }),
    };
    const renderTitle = () => {
        if (React.isValidElement(title)) {
            return title;
        }
        else if (isString(title)) {
            return React.createElement("span", { className: classes.tabText }, title);
        }
        return null;
    };
    const handleClick = (e) => {
        if (onClick) {
            onClick({
                ...e,
                itemKey,
            });
        }
        change(itemKey);
    };
    return (React.createElement("div", { ref: ref, ...others, id: curItemId, className: classes.tab, onClick: handleClick },
        renderContent
            ? renderContent({
                title,
                active,
            })
            : renderTitle(),
        React.createElement("div", { className: classNames(classes.activeLine, {
                [`${clsPrefix}-active-line--enter`]: active,
                [`${clsPrefix}-active-line--exit`]: !active,
            }) },
            React.createElement("div", { className: `${clsPrefix}-active-line-block` }))));
});
CnTabItem.displayName = 'Tab.Item';
